var Cart = (function ($, document) {
    'use strict';

    var
        loaded = false,
        $cartObject,
        $qty,
        $preview,
        $total;
    
    return {
        setup: function(cartSelector) {
            $cartObject = $(cartSelector);
            $qty = $cartObject.find('.cart-preview-qty');
            $total = $cartObject.find('.cart-preview-total');
            $preview = $cartObject.find('#cart-preview-dropdown').add('#mobile-cart-preview-dropdown');
        },

        isEmpty: function() {
            return parseInt( $qty.first().text() ) === 0;
        },

        setLoaded: function(state) {
            loaded = state;
        },

        animateAdded: function() {
            var $element = $cartObject.find('> .preview-cart-badge');

            setTimeout(function() {
                $element.removeClass('add');
            }, 350);

            $element.addClass('add');
        },

        getCartUrl: function() {
            return $cartObject.data('cart-url');
        },

        runCommand: function (url, _params) {
            $(document).trigger('cart/runCommand/before', [url]);
            
            var
                self = this,
                params = {
                    _token: $cartObject.data('csrf-token')
                };
            
            if(_params === undefined) {
                _params = {};
            }
            
            $.extend(params, _params);
            
            return $.post(url, params)
                .always(function () {
                    $(document).trigger('cart/runCommand/after', [url]);
                })
                .success(function (response) {
                    if(response.cart) {

                        $(document).trigger('cart/runCommand/toggleCartInCA', [{
                            cart_qty:response.cart.qty
                        }]);

                        $cartObject.find('> .btn-circle').toggleClass('badge-hidden', ! response.cart.qty);

                        var rawTotal = parseFloat($total.data('raw-total') || '0');

                        if(loaded && response.cart.raw_total > rawTotal) {
                            self.animateAdded();
                        }

                        // if(loaded && response.cart.qty > $qty.first().text()) {
                        //     self.animateAdded();
                        // }

                        loaded = true;

                        $qty.each(function() {
                            $(this).text(response.cart.qty);
                        });

                        $total.each(function() {
                            $(this).text(response.cart.total).data('raw-total', response.cart.raw_total);
                        });

                        $preview.each(function() {
                            $(this).html(response.cart.preview);
                        });

                        var $html = $(response.cart.summary);

                        $('#order-cart-summary').children().html( $html.html() );
                    }

                    $(document).trigger('cart/runCommand/success', [url, response]);
                })
                .fail(function () {
                    $(document).trigger('cart/runCommand/fail', [url]);
                });
        }
    };
    
})(jQuery, document);
